export interface VideoCategory {
  title: string;
  slug: string;
  description?: string;
}

export const videoCategories: VideoCategory[] = [
  {
    title: 'All Videos',
    slug: 'all',
    description: 'Browse all available videos'
  },
  {
    title: 'Architecture',
    slug: 'architecture',
    description: 'Videos about architectural design and buildings'
  },
  {
    title: 'Mediterranean',
    slug: 'mediterranean',
    description: 'Mediterranean lifestyle and culture videos'
  },
  {
    title: 'Artists',
    slug: 'artists',
    description: 'Featured artists and their work'
  },
  {
    title: 'Cars',
    slug: 'cars',
    description: 'Automotive content and car features'
  },
  {
    title: 'Collectors',
    slug: 'collectors',
    description: 'Stories from collectors and their collections'
  }
];